import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../lib/api';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get('token') || '';
  const [nw, setNw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [ok, setOk] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setMsg('');
    if (!token) return setMsg('Missing token. Use the link from your email.');
    if (nw.length < 6) return setMsg('Password must be at least 6 characters');
    if (nw !== confirm) return setMsg('Passwords do not match');
    setBusy(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: nw });
      setOk(true); setMsg('Password updated. Redirecting to login…');
      setTimeout(() => nav('/login'), 1500);
    } catch (ex) { setMsg(ex.response?.data?.error || 'Failed'); }
    finally { setBusy(false); }
  };

  return (
    <div className="tm-board-bg" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div className="tm-modal" style={{ maxWidth: 420, width: '100%' }} data-testid="reset-password-page">
        <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700 }}>Choose a new password</h2>
        <p style={{ margin: '0 0 16px', fontSize: 13, color: 'var(--trello-text-muted)' }}>
          Reset links expire 1 hour after being sent.
        </p>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="tm-label">New password</label>
            <input className="tm-input" type="password" value={nw} onChange={(e) => setNw(e.target.value)} required data-testid="rp-new" />
          </div>
          <div>
            <label className="tm-label">Confirm password</label>
            <input className="tm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="rp-confirm" />
          </div>
          {msg && <div className={ok ? 'tm-success-msg' : 'tm-error-msg'} style={{ color: ok ? '#61BD4F' : '#DE350B', fontSize: 13 }} data-testid="rp-msg">{msg}</div>}
          <button type="submit" className="tm-btn w-full" disabled={busy} data-testid="rp-submit">
            {busy ? 'Updating…' : 'Set new password'}
          </button>
          <div style={{ textAlign: 'center', fontSize: 13 }}>
            <Link to="/login" style={{ color: 'var(--trello-blue)' }}>Back to login</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
